import {h, Fragment} from "preact"
import { AutocompleteElement } from "@nosto/preact"
import { formatCurrency, productImagePlaceholder, checkProdPriceVaries } from "../../helpers"

export default function AutocompleteProduct({ product }) {
    const usaBadge = !!product.tags1?.find(tag => tag === "USA");
    const priceRange = checkProdPriceVaries(product);

    return (
        <AutocompleteElement class="product-item" product={product}>
            <a href={product.url}>
                <div
                    class="ns-autocomplete-prod-wrapper"
                    data-url={product.url}
                    data-nosto-element="product"
                >
                    <div class="ns-autocomplete-prod-image-wrap">
                        {usaBadge && 
                            <div class="ns-autocomplete-img-badge-container">
                                <img
                                    src="https://www.thefryecompany.com/cdn/shop/files/frye_made-in-the-usa-badge_100x.png?v=1680554825"
                                    width={30}
                                    height={24}
                                    alt="Badge for Frye product made in the USA"
                                />
                            </div>
                        }
                        <img
                            class="ns-autocomplete-prod-main-img"
                            srcset={`
                                ${product.imageUrl.replace('.jpg', '_200x.jpg').replace('.png', '_200x.png')} 200w,
                                ${product.imageUrl.replace('.jpg', '_300x.jpg').replace('.png', '_300x.png')} 300w,
                                ${product.imageUrl.replace('.jpg', '_400x.jpg').replace('.png', '_400x.png')} 400w`}
                            src={product.imageUrl.replace('.jpg', '_600x.jpg').replace('.png', '_600x.png') ?? productImagePlaceholder}
                            alt={product.name}
                            width={100}
                            height={150}
                        />
                    </div>
                    <div class="ns-autocomplete-prod-details">
                        <div class="ns-autocomplete-prod-name">
                            {product.name}
                        </div>
                        {/* <div class="ns-autocomplete-prod-price-container">
                            {priceRange.varies ? (
                                <>
                                    <span class="visually-hidden sr-only">Price range:</span>
                                    <span class="price final-price">{`${formatCurrency(priceRange.min)} - ${formatCurrency(priceRange.max)}`}</span>
                                </>
                            ) : (product.listPrice && product.listPrice > product.price) ? (
                                <>
                                    <span class="visually-hidden sr-only">Sale price:</span>
                                    <span class="price sale-price">{formatCurrency(product.price)}</span>
                                    <span class="visually-hidden sr-only">Original price:</span>
                                    <span class="price original-price">{formatCurrency(product.listPrice)}</span>
                                </>
                            ) : (
                                <>
                                    <span class="visually-hidden sr-only">Final price:</span>
                                    <span class="price final-price">{formatCurrency(product.price)}</span>
                                </>
                            )}
                        </div> */}
                    </div>
                </div>
            </a>
        </AutocompleteElement>
    )
}